import { Button, ButtonProps } from "@/components/ui/button";
import { cn } from "@/lib/utils.ts";
import { LoaderCircle } from "lucide-react";

export function LoadingButton({
  className,
  children,
  disabled,
  loading,
  ...props
}: ButtonProps & { loading: boolean }) {
  return (
    <Button
      className={cn(
        loading
          ? "[&>*]:invisible [&>*:first-child]:visible"
          : "[&>*:first-child]:invisible [&>*]:visible ",
        className,
      )}
      {...props}
      disabled={loading || disabled}
    >
      <LoaderCircle className="absolute h-4 w-4 animate-spin" />
      {typeof children === "string" ? <span>{children}</span> : children}
    </Button>
  );
}
